'use strict';

import dayjs from 'dayjs';

/** @param {string|import('dayjs').Dayjs} value */
export function formatUsDate(value) {
	if (value == null || value === '') return '—';
	const d = dayjs(value);
	return d.isValid() ? d.format('MM/DD/YYYY') : String(value);
}
